import { PlatformModulesEnum, PLATFORM_MODULES_PERMISSIONS } from '@thinknet-gmbh/platform-common';

export const PLAN_WERK_PERMISSIONS = Object.values(
  PLATFORM_MODULES_PERMISSIONS[PlatformModulesEnum.PLAN_WERK_MODULE]
);

export const DEFAULT_PERMISSION_DOC = {
  name: '',
  isConfirmed: false,
  permissions: [],
};
